export default __webpack_public_path__ + "static/swordsandravens-52989414ba0b4e35bbaf25e7ee87104c.jpg";